

















































































































import CreateMeditationViewModel from "@models/meditations/create/createMeditationViewModel";
import CategoryViewModel from "@models/categoryViewModel";
import { COVER_IMAGE_RATIO, BACKGROUND_IMAGE_RATIO } from "@/appSettings";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import MeditationTranslateViewModel from "@models/meditations/create/meditationTranslateViewModel";
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";

@Component
export default class CreateMeditationComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  currentAudioGroup: AudioGroupViewModel = null;
  isEditAudio = false;
  categories: CategoryViewModel[] = [];
  coverImageRatio = COVER_IMAGE_RATIO;
  backgroundImageRatio = BACKGROUND_IMAGE_RATIO;
  get title(): string {
    return this.id ? "Редактирование медитации" : "Добавление медитации";
  }
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  vm: CreateMeditationViewModel = new CreateMeditationViewModel();
  onAnimationChanged(item: AnimationResponse) {
      if (item && item.Url) {
        this.vm.animationUrl = item.Url;
      } else {
        this.vm.animationUrl = '';
      }
  }
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.initLanguages(this.languages);
    const catRes = await this.$api.MeditationService.getCategoriesAsync();
    this.categories = (catRes.Items || []).map((x) => new CategoryViewModel(x));
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.MeditationService.getMeditationAsync(this.id);
    this.vm.fromServerModel(res);
    this.isLoading = false;
  }
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.MeditationService.updateMeditationAsync(
      request
    );
    if (res) {
      this.$dialog.success("Медитация успешно обновлена");
      this.$router.back();
    }
    this.isLoading = false;
    this.isEditAudio = false;
  }
  audioGroupChanged(audioGroup: AudioGroupViewModel) {
    if (audioGroup == null) {
      this.currentAudioGroup = null;
      this.isEditAudio = false;
      return;
    }
    if (this.audioAddMode == "edit") {
      Object.assign(this.currentAudioGroup, audioGroup);
      this.isEditAudio = false;
    } else if (this.audioAddMode == "add") {
      this.vm.audios.push(audioGroup);
    }
    this.currentAudioGroup == null;
    this.isEditAudio = false;
  }
  audioAddMode: "edit" | "add" | null = null;
  startAddAudio() {
    this.currentAudioGroup = new AudioGroupViewModel(this.languages);
    this.audioAddMode = "add";
    this.isEditAudio = true;
  }
  startEditAudioGroup(item: AudioGroupViewModel) {
    this.currentAudioGroup = item;
    this.audioAddMode = "edit";
    this.isEditAudio = true;
  }
  deleteAudioGroup(item: AudioGroupViewModel) {
    this.vm.audios = this.vm.audios.filter((x) => x != item);
  }
}
